import { handleActions } from 'redux-actions';
import { assoc, mergeLeft, isEmpty } from 'ramda';

import {
  newReportNextStep,
  newReportReset,
  requestParsePdf,
  requestParsePdfSuccess,
  requestParsePdfFailure,
  storePdfReport,
  setTransmissionType,
  setUnscheduledVisitReason,
} from 'store/actionCreators/newReport';
import { NOT_APPLICABLE } from 'constants/common';

const defaultState = {
  step: 1,
  parsingDataLoading: false,
  pdfParsingData: null,
};

export default handleActions(
  {
    [storePdfReport]: (state, { payload }) => assoc('pdfBase64', payload, state),
    [requestParsePdf]: state => assoc('parsingDataLoading', true, state),
    [requestParsePdfSuccess]: (state, { payload: { response } }) =>
      mergeLeft(
        {
          pdfParsingData: {
            batteryLife: response.batteryLife,
            pacing: response.pacing,
            shock:
              response.vt === 'Off' || response.vt === 'Monitor'
                ? response.shock || NOT_APPLICABLE
                : (!!parseInt(response.lowerVt, 10) && response.lowerVt) ||
                  response.detection ||
                  NOT_APPLICABLE,
            // detection: response.detection || NOT_APPLICABLE,
            alert: response.alert === 'Alert found',
            sentOnDate: response.sentOnDate,
            sentOnHour: response.sentOnHour,
            shocksDate:
              isEmpty(response.shocksDate) || !response.shocksDate ? [null] : response.shocksDate,
          },
          parsingDataLoading: false,
        },
        state,
      ),
    [requestParsePdfFailure]: mergeLeft({
      pdfParsingData: {
        shocksDate: [null],
        shock: NOT_APPLICABLE,
      },
      parsingDataLoading: false,
    }),
    [newReportNextStep]: state => assoc('step', state.step + 1, state),
    [setTransmissionType]: (state, { payload }) => assoc('transmissionType', payload, state),
    [setUnscheduledVisitReason]: (state, { payload }) =>
      assoc('unscheduledVisitReason', payload, state),
    [newReportReset]: () => defaultState,
  },
  defaultState,
);
